(ns dashboard.views.questionnaire.question-lab.common
  (:require [io.repliance.answer-data :as answer-data]))

(defn get-question-ids [db questionnaire-id]
  (get-in db [:question-lab questionnaire-id :question-ids]))

(defn set-question-ids [db questionnaire-id question-ids]
  (assoc-in db [:question-lab questionnaire-id :question-ids] question-ids))

(defn set-question-index [db questionnaire-id index]
  (assoc-in db [:question-lab questionnaire-id :question-index] index))

(defn get-edit-answer-state [db questionnaire-id]
  (get-in db [:question-lab questionnaire-id :edit-answer-state]))

(defn answer->edit-state [answer applied-analyses]
  (let [response (answer-data/get-response (:source answer) answer)
        comment (answer-data/get-comment (:source answer) answer)
        multi-select-options (when (or (= "human" (:source answer))
                                       (= "inferred_faq" (:source answer)))
                               (set (keep #(when (and (:multi %)
                                                      (:selected %))
                                             (:id %))
                                          (:options answer))))
        single-select-options (when (or (= "human" (:source answer))
                                      (= "inferred_faq" (:source answer)))
                                (set (keep #(when (and (not (:multi %))
                                                       (:selected %))
                                              (:id %))
                                           (:options answer))))]
    (cond-> nil
      response (assoc :response response)
      comment (assoc :comment comment)
      (seq multi-select-options) (assoc :multi-select-options multi-select-options)
      (seq single-select-options) (assoc :single-select-options single-select-options)
      (:analysis answer) (assoc :analysis-content (-> answer :analysis :content))
      applied-analyses (assoc :applied-analysis-version-ids (set (map :version-id applied-analyses))))))

(defn editor-dirty?
  "Note: don't use directly for making a subscription that depends on db, use layer-3 caching."
  [db questionnaire-id]
  (let [edit-state (get-edit-answer-state db questionnaire-id)]
    (:dirty? edit-state)))

(defn highlighted-text [text {:keys [start end]}]
  [:span
   [:span (subs text 0 start)]
   [:b (subs text start end)]
   [:span (subs text end (count text))]])

(defn render-document-answer [answer]
  (let [answer-text (or (:answer answer) ;; :answer field of Haystack Answer class
                        (:response answer)) ;; Legacy data had the :answer text in :response field
        document-content (-> answer :meta :source_documents first :content)
        legacy-document-content (-> answer :meta :document_content)
        context (-> answer :context)
        offsets-in-document (-> answer :offsets_in_document first)
        offsets-in-context (-> answer :offsets_in_context first)]
    [:div
     ;; Show answer text as is, if we don't have the document content that the answer text was found in
     (when (and answer-text
                (nil? document-content)
                (nil? context))
       [:div answer])
     ;; Prefer showing document content, if it is present
     (when document-content
       [:div
        (if offsets-in-document
          [highlighted-text document-content offsets-in-document]
          document-content)])
     ;; Show context if we don't have document content
     (when (and (not document-content)
                context)
       [:div
        (if offsets-in-context
          [highlighted-text context offsets-in-context]
          context)])
     ;; Fallback to legacy document_content otherwise
     (when (and (not document-content)
                (not context)
                legacy-document-content)
       [:div
        legacy-document-content])]))
